// The /embed/* page runs inside USM, on the same origin as a normal HOS tab, so the two
// share localStorage and the session cookie. This page must never touch that session:
// it keeps its own storage in memory, reads nothing of the normal tab's, and sends no
// shared write or storage event to it. Imported first in main.tsx, before anything can
// read or write storage. Dependency-free, so tests and the auth files can load it.

export const IS_EMBED_PAGE = typeof window !== "undefined" && window.location?.pathname?.startsWith("/embed/") === true;

// A 401 here starts a renewal (EmbedHost), so the server's "Token expired" would still be
// on the form with a new token in place. This stays true until the next try.
export const EMBED_NOT_AUTHENTICATED_MESSAGE = "That did not go through because HOS had to sign in again. Please try again.";

export function createMemoryStorage(): Storage {
  const values = new Map<string, string>();
  return {
    get length() { return values.size; },
    key: (index) => [...values.keys()][index] ?? null,
    getItem: (key) => values.get(String(key)) ?? null,
    setItem: (key, value) => { values.set(String(key), String(value)); },
    removeItem: (key) => { values.delete(String(key)); },
    clear: () => values.clear(),
  };
}

if (IS_EMBED_PAGE) {
  Object.defineProperty(window, "localStorage", { value: createMemoryStorage(), configurable: true });
}
